import Button from "@/common/Button";
import DropdownMenu from "@/common/DropdownMenu";
import React, { useCallback, useState } from "react";
import ArrowDropdown from "../Svg/ArrowDropdown";
import InputText from "@/common/InputText";
import { SearchNormal1 } from "iconsax-react";
import CategoryItem from "../SearchFilter/CategoryItem";
import { BrandSearchMenuType } from "@/types/Search";
import { toast } from "react-toastify";
import Spinner from "@/common/Spinner,";

function BrandSearchMenu({
  brandMenuData,
  checkedBrandItems,
  getBrandForSearch,
  setCheckedBrandItems,
  setBrandMenuData,
  setCheckedBrandNames,
}: BrandSearchMenuType) {
  const [isLoading, setIsLoading] = useState(false); // وضعیت لودینگ

  const handleCheckboxBrandChange = (id: string, name: string) => {
    setCheckedBrandItems((prev: Record<string, boolean>) => ({
      ...prev,
      [id]: !prev[id],
    }));

    setCheckedBrandNames((prev) => {
      // بررسی وجود آیتم در آرایه
      const exists = prev.some((item) => item.id === id);

      if (exists) {
        // اگر قبلاً اضافه شده بود، حذفش کن
        return prev.filter((item) => item.id !== id);
      } else {
        // در غیر این صورت، اضافه‌اش کن
        return [...prev, { id, name }];
      }
    });
  };
  const handleSearchBrand = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      setIsLoading(true); // شروع لودینگ

      try {
        const response = await getBrandForSearch({
          text: e?.target?.value,
        });
        if (response?.isSuccess) {
          setBrandMenuData(response?.data);
        } else {
          toast.error("خطا در انجام عملیات ");
        }
      } catch (err) {
        console.log("error from get brand", err);
      }
      setIsLoading(false); // پایان لودینگ
    },
    [getBrandForSearch]
  );

  return (
    <DropdownMenu
      direction="rtl"
      menuClass="p-0 border top-14 right-0"
      customeClass="w-max py-1 px-1 rounded-lg bg-white"
      trigger={
        <Button variant="primary" className="h-8 px-3">
          <span className="text-lg ws-gray-500">{"برند"}</span>
          <ArrowDropdown />
        </Button>
      }
    >
      <div className="bg-white w-80  rounded-3xl p-3">
        <InputText
          type="search"
          placeholder="جستجو"
          className="h-10 search-input text-base  border-2 border-ws-gray-800 container-contact-input"
          containerClass="w-full  "
          badge={<SearchNormal1 color="#686868" size={18} />}
          badgeTextClass="pr-0 border-r-0"
          onChange={handleSearchBrand}
        />
        <div className="h-52 overflow-auto mt-3 cat-search">
          {isLoading ? (
            <div className="flex flex-col items-center justify-start gap-3 h-full">
              <Spinner />
              در حال بارگذاری...
            </div>
          ) : brandMenuData?.length > 0 ? (
            brandMenuData?.map((brand) => (
              <CategoryItem
                key={brand.id}
                category={brand}
                checkedItems={checkedBrandItems}
                handleCheckboxChange={handleCheckboxBrandChange}
              />
            ))
          ) : (
            <div>دیتایی موجود نیست</div>
          )}
        </div>
      </div>
    </DropdownMenu>
  );
}

export default BrandSearchMenu;
